/**
 * TadReamk Patent Product Data
 *
 * @deprecated - This file uses the legacy structure with hybrid merge approach.
 * MIGRATION PENDING: Will be migrated to JSON translations structure.
 * See: public/locales/en/products/tadreamk-eye.json for the new pattern.
 *
 * For now, this product continues to work using the old translation pattern.
 */

import tadreamkPatentImage from "../../assets/images/products/Patent search.webp";

import { FEATURE_ICONS, STATUS_ICONS } from "../../configs/emojis";
import { APP_CONFIG } from "../../configs/config";

const tadreamkPatentData = {
  id: 3,
  image: tadreamkPatentImage,
  title: "TadReamk Patent",
  abstract:
    "Search relevant patents fast, compare claims and embodiments, and understand what’s similar—and what’s truly different. TadReamk Patent accelerates prior‑art review with explainable comparisons and actionable insights.",
  ctaUrl: APP_CONFIG.TADREAMK_PATENT_URL || "https://patent.tadreamk.com",
  ctaText: "Explore Patents",
  category: "Legal & Compliance",
  primaryFeatureTag: "Patent Search",
  imageAlt: "TadReamk Patent prior art search and comparison",
  ctaPlacement: "top",
  showOverviewHeading: false,
  description: [
    {
      icon: FEATURE_ICONS.SEARCH,
      title: "Precision search",
      text: "Query global patent data with natural language or structured fields, then refine without losing context. Semantic matching expands keywords to conceptually related terms, homologous technologies, and translation variants. Powerful filters—classes, dates, assignees, inventors, jurisdictions, citations, and legal status—let you converge on the exact slice of prior art that matters.",
    },
    {
      icon: FEATURE_ICONS.DETAILS || FEATURE_ICONS.BAR_CHART,
      title: "Claim‑level comparisons",
      text: "Side‑by‑side views align independent and dependent claims to expose nuance. We auto‑highlight overlapping phrases, normalize reference numerals, surface backward/forward citation chains, and link to embodiment figures so you can evaluate conflict, coverage, and potential design‑around routes in minutes instead of hours.",
    },
    {
      icon: FEATURE_ICONS.TARGET,
      title: "Similar vs. different",
      text: "Explainable highlights show why two patents are similar—shared terminology, structural patterns, or common embodiments—and where they clearly diverge, from claim scope and novelty points to inventive steps and limitations. Visual cues (overlap vs. differentiation) make it obvious at a glance where risk resides and where room remains.",
    },
    {
      icon: FEATURE_ICONS.BAR_CHART,
      title: "Landscape insights",
      text: "See the field from 10,000 meters: assignee clusters, filing velocity, jurisdictional spread, and technology hotspots. Identify whitespace and fast‑rising niches, then export charts and evidence packs tailored for internal memos, board updates, or outside counsel review.",
    },
    {
      icon: STATUS_ICONS.CHECK,
      title: "Built for patent teams",
      text: "Organize searches by matter, tag and rate references, attach relevance notes, and maintain an auditable trail from first query to final opinion or office‑action strategy. CSV/PDF exports and APIs integrate with docketing, e‑discovery, and review tooling so your workflow stays connected.",
    },
  ],
  testimonial: {
    text: "TadReamk Patent has streamlined our patent research process. The comprehensive search capabilities and intuitive interface have made our prior art analysis much more efficient.",
    author: "Dr. Michael Chen",
    title: "Patent Attorney, Innovation Labs",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
  },
};

export default tadreamkPatentData;
